import { redirectToContractSales, redirectToPlan } from 'businessCommon/src/services';
import { lang, commonLang } from '@umu/ukit-lang';
import './pricingFooter.scss';
import React, { useCallback } from 'react';
import { IProps } from '@umu/umu-types';
import { If, PreImg, Button } from 'common/src/components';

import { PLAN_TYPE } from '@umu/umu-types';
export const PricingFooter = (props: IProps) => {
    const { isRegisterUser, siteHost, platform } = props;
    const onPlan = useCallback(
        (planId: number) => {
            redirectToPlan(platform, isRegisterUser, planId);
        },
        [siteHost, isRegisterUser, platform],
    );
    return (
        <>
            <If condition={platform === 'twww'}>
                <div className="partner-welcome">
                    <PreImg>
                        <img className="footer-left-img" src={require(`../../images/common_footer_left.png`)} />
                    </PreImg>
                    <PreImg>
                        <img className="footer-right-img" src={require(`../../images/common_footer_right.png`)} />
                    </PreImg>
                    <div className="partner-welcome-title">{lang('欢迎使用 UMU')}</div>
                    <div className="partner-welcome-des">
                        {lang('现在就使用 UMU 提升学习效果，创造教与学的全新体验')}
                    </div>
                    <div className="partner-welcome-footer">
                        <div className="footer-content">
                            <If condition={isRegisterUser}>
                                <Button
                                    onClick={() => redirectToContractSales(platform)}
                                    className="contact-btn"
                                    alias="striking"
                                >
                                    {commonLang('联系 UMU')}
                                </Button>
                            </If>
                            <If condition={!isRegisterUser}>
                                <>
                                    <Button
                                        className="free-btn"
                                        onClick={() => onPlan(PLAN_TYPE.BASIC)}
                                        alias="striking"
                                    >
                                        {commonLang('免费注册')}
                                    </Button>
                                    <Button
                                        onClick={() => redirectToContractSales(platform)}
                                        className="contact-btn"
                                        alias="striking"
                                    >
                                        {commonLang('联系 UMU')}
                                    </Button>
                                </>
                            </If>
                        </div>
                    </div>
                </div>
            </If>
        </>
    );
};
